import React from 'react';
import HeaderSectionComponent from '../HeaderSectionComponent/HeaderSectionComponent';
import TermsAndConditionsComponent from '../TermsAndConditionsComponent/TermsAndConditionsComponent';
import CalloutCardComponent from '../CalloutCardComponent/CalloutCardComponent';

function TermsAndConditionsPageComponent({emailAddress, isWaiting, lingua, onClose, setMarketingOptOut, site, siteName, updatePage}) {
    let options = {'sitename': siteName};
    let cardContent = (
        <TermsAndConditionsComponent
            lingua={lingua}
            siteName={siteName}
            isWaiting={isWaiting}
            updatePage={updatePage}
            onClose={onClose}
            emailAddress={emailAddress}
            site={site}
            setMarketingOptOut={setMarketingOptOut}
        />
    );
    return (
        <div className="TermsAndConditionsPageComponent border-border-color">
            <HeaderSectionComponent title={lingua.read('lex.header.terms.conditions', options)}/>
            <CalloutCardComponent content={cardContent} error={''} errorTitle={''} />
        </div>
    );
}

export default TermsAndConditionsPageComponent;
